import styled, { css } from 'styled-components'
import Paragraph from '../../typography/paragraph'

export const StyledLabel = styled.label(
  () => css`
    position: relative;
    cursor: pointer;
    display: block;
    padding-left: 3rem;
    
    & + & {
      margin-top: 1.6rem;
    }
  `
)
export const StyledButtonLabel = styled.label(
  () => css`
    position: relative;
    cursor: pointer;
    display: contents;
  `
)
export const StyledRadio = styled.input(
  ({ theme: { COLOR } }) => css`
    position: absolute;
    overflow: hidden;
    opacity: 0;
    height: 0;
    width: 0;

    &:checked {
      + ${StyledCustomRadio} {
        &:after {
          content: '';
          position: absolute;
          width: 1rem;
          height: 1rem;
          border-radius: 50%;
          background-color: ${COLOR.PRIMARY_BLACK};
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  `
)

export const StyledCustomRadio = styled.span(
  ({ theme: { COLOR } }) => css`
    position: absolute;
    left: 0;
    top: 0.2rem;
    border: 2px solid ${COLOR.PRIMARY_BLACK};
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    display: flex;
  `
)

export const StyledTitle = styled(Paragraph)(
  () => css`
    display: block;
    margin-bottom: 0.2rem;
    font-weight: 500;
  `
)

export const StyledSubTitle = styled.span(
  ({ theme: { COLOR } }) => css`
    margin-left: 8px;
    padding: 4px;
    background-color: ${COLOR.NEUTRAL_GREY_1};
    border: 1px solid ${COLOR.NEUTRAL_GREY_2};
    border-radius: 2px;
  `
)

export const StyledDescription = styled(Paragraph)(
  ({ theme: { COLOR } }) => css`
    display: block;
    color: ${COLOR.PRIMARY_BLACK};
  `
)

export const StyledRadioButton = styled.input(
  ({ theme: { COLOR } }) => css`
    position: absolute;
    overflow: hidden;
    opacity: 0;
    height: 0;
    width: 0;

    &:checked {
      + ${StyledCustomRadioButton} {
          background-color: ${COLOR.PRIMARY_BLACK};
          color: ${COLOR.PRIMARY_WHITE};
          .sub-title {
            color: ${COLOR.PRIMARY_BLACK};
          }
      }
    }
  `
)

export const StyledCustomRadioButton = styled.span(
  ({ theme: { COLOR } }) => css`
  border: 1px solid  ${COLOR.PRIMARY_BLACK};
  color: ${COLOR.PRIMARY_BLACK};
  font-weight: 600;
  font-size: 1.6rem;
  border-radius: 8px;
  line-height: 2rem;
  padding: 0.8rem 1.6rem;
  min-height: 4.4rem;
  justify-content: center;
  align-items: center;
  width: auto;
  display: flex;
  background-color: ${COLOR.PRIMARY_WHITE};
  aspect-ratio: 4/1;

  &:hover {
    box-shadow: 0 0 0 1px ${COLOR.PRIMARY_BLACK};
  }
`)
